import React from 'react';

const PDFViewer = (props) => {

  return (
    <>
      <object data={`${props.pdfFile}`} style={{ width: '100%', height: '100%' }} type="application/pdf">
        <embed src={`${props.pdfFile}`} type="application/pdf" />
      </object>
    </>
  );
}


export default PDFViewer;
